export default __webpack_public_path__ + "static/yapsody-bf9404363a20ec0185491709349a47f2.svg";